import { putPromise } from "./request-promise";

export function updateFragSizeRangeFineGoals(fragSizeRangeFineGoalParams) {
	return putPromise(
		'/api/dashboards/highchart_analytics/update_fines_goal',
		fragSizeRangeFineGoalParams,
		(data) => data || null
	);
}
